<template>
        <div>
        <div v-if="loading" class="flex flex-col gap-2">
            <div v-for="i in 8" :key="i" class="bg-gray-200 animate-pulse h-4 w-full rounded-sm"></div>
        
        </div>
        <div v-else class="wikipedia md:line-clamp-[8] line-clamp-[12]" v-html="sobrehtml"></div>
            
        </div>
        <a v-if="colla.wikipedia!==null" :href="'https://ca.wikipedia.org/w/index.php?title='+colla.wikipedia" target="_blank"               
        class="p-1 hover:bg-gray-300 bg-gray-200 hover:underline rounded-full w-fit flex items-center">
                        <font-awesome-icon :icon="['fab', 'wikipedia-w']" class="mr-2 text-xl p-2 aspect-square bg-white rounded-full"/>
                        <p>Llegeix l'article complet...</p>
        <font-awesome-icon :icon="['fas', 'arrow-up-right-from-square']" class="p-2"/></a>

        <a v-else :href="'https://ca.wikipedia.org/w/index.php?title='+colla.nom+'&action=edit&redlink=1'" target="_blank"               
        class="p-1 hover:bg-red-300 hover:underline rounded-full w-fit flex items-center bg-red-200">
                        <font-awesome-icon :icon="['fab', 'wikipedia-w']" class="mr-2 text-xl p-2 aspect-square bg-white rounded-full"/>
                        <p>Redacta'l ara!</p>
        <font-awesome-icon :icon="['fas', 'arrow-up-right-from-square']" class="p-2"/></a>
</template>

<script setup async>
import {ref,inject, onMounted, defineProps} from 'vue'

const props = defineProps({
    colla:{
        type:String,
        required:false,
    },
    obj:{
        type:Object,
        required:false
    }
})
const dades = inject('dades')

const colla = ref(props.obj ? props.obj : dades.find(c => c.id === props.colla))
const sobrehtml= ref("")

const loading = ref(true)

onMounted(async () => {
    /* const url = "https://ca.wikipedia.org/w/api.php?" +
        new URLSearchParams({
            origin: "*",
            action: "query",
            format: "json",
            prop: "extracts",
            titles: colla.wikipedia,
            formatversion: "2",
            exchars: "500",
            explaintext: 1
        })
        console.log(url)
    try {
        const req = await fetch(url);
        const json = await req.json();
        console.log(json.query.pages[0].extract);
        sobre.value = json.query.pages[0].extract;
    } catch (e) {
        console.error(e);
    } */
   let article = colla.value.wikipedia ? decodeURIComponent(colla.value.wikipedia) : '';    
    const url2 = "https://ca.wikipedia.org/w/api.php?" +
    new URLSearchParams({
        origin: "*",
        action: "parse",
        page: article,
        format: "json",
        prop: "text"
    })
    //console.log(url2)

try {
    const req = await fetch(url2);
    const html = await req.json();
    let raw
    if (html.parse) raw = html.parse.text["*"]; else raw="<p>Aquesta colla no te un article a Viquipèdia.</p>", console.log(html.error.code);


    const parser= new DOMParser();
    const doc = parser.parseFromString(raw, "text/html");

    doc.querySelectorAll('.mw-editsection, .navbox, .reflist, .metadata, .infobox, .reference, .mw-references-wrap').forEach(el => el.remove())
    doc.querySelectorAll('figure, table').forEach(el => el.remove())

    const headings=Array.from(doc.querySelectorAll('.mw-heading2, h3, h4, h5, h6'))
    const deletefrom = headings.find(h =>
    /bibliograf[íi]a/i.test(h.textContent) ||
    /refer[èe]ncies/i.test(h.textContent) ||
    /refer[èe]ncia/i.test(h.textContent)
    );

    if (deletefrom){
    let next = deletefrom.nextElementSibling;
    while(next) {
        const toRemove = next;
        next = next.nextElementSibling;
        toRemove.remove();
    }
    deletefrom.remove();
    }
    let parsed = doc.body.innerHTML;
    parsed = parsed.replace(/href="\/wiki/g, 'target="_blank" href="https://ca.wikipedia.org/wiki');

    parsed = parsed.replace(/href="\/w\//g, 'target="_blank" href="https://ca.wikipedia.org/w/');
    sobrehtml.value = parsed;
} catch (e) {
    console.error(e);
}
loading.value = false;
})

</script>

<style>
.wikipedia a{
    color:#36c;
}

.wikipedia .new{
    color:#9f3526;
}


.wikipedia h2{
    font-size:1.125rem;
    margin-top:1rem;
    color:#dc2626;
    font-weight: bold;
}   

</style>
